import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const cigarsConfig: ServicePageConfig = {
  title: 'Cigars - Bespoke Shopping | FGA Prestige',
  description: 'Curating premium cigars and rare tobacco from exclusive manufacturers through our bespoke shopping service.',
  slug: 'bespoke-shopping/cigars',
  heroImage: '/Bespoke Shopping/Retail Partners/CIGARS/hero.png',
  serviceName: 'CIGARS',
  whySectionA: {
    title: 'Smoke & Splendor: Celebrating the World’s Finest Cigars',
    content: 'Picture the hush of a private lounge, crystal tumblers clinking gently over single-malt ice, and a whisper blue smoke curling through amber lamplight. In this realm of cultivated taste, a truly exceptional cigar is more than a momentary indulgence—it is an heirloom of terroir, time, and meticulous craft.',
    image: '/Bespoke Shopping/Retail Partners/CIGARS/body/1.png',
    imageAlt: 'Premium Cigar Selection'
  },
  whySectionC: {
    title: 'Treasures of the Humidor',
    content: 'Roll out the red carpet for Cohiba Behike—the Cuban superstar whose rare medio tiempo leaves now command nearly US $300 per stick in London and Hong Kong, a 50 percent leap that has only intensified desire among collectors. From Switzerland\'s ateliers comes Davidoff Oro Blanco, a Dominican puro blended from tobaccos aged up to 17 years; at roughly US $900 a cigar, each is individually numbered and released only when the master blender deems the moment "special enough". The Dominican Republic also gifts us Arturo Fuente Opus X, whose micro-batch "Heaven & Earth" editions arrive in jewel-box humidors and vanish almost instantly from shelves.',
    image: '/Bespoke Shopping/Retail Partners/CIGARS/body/2.png',
    imageAlt: 'Cigar Expert Selection'
  },
  whySectionB: {
    title: 'Curated Experiences',
    benefits: [
      {
        title: '',
        description: 'Acquiring these rarities is a dance of access and expertise. Our concierge team nurtures relationships from Havana to Santiago, securing Behike allocations before they leave the factory and arranging private tastings of newly rolled Oro Blancos at our Prestige Lounge.'
      },
      {
        title: '',
        description: 'A cigar is more than aromatic leaf—it is a chronicle of rivers, soils, and artisans whose patience can\'t be rushed. Light one, and you partake in decades of quiet mastery. For those who require their pleasures as curated as their portfolios, our collection awaits—ready to ignite stories worth savoring long after the embers fade.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/CIGARS/body/3.png',
    imageAlt: 'Premium cigar collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/CIGARS/CTA_Banner/banner.png'
}

const CigarsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Cigars - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Curating premium cigars and rare tobacco from exclusive manufacturers through our bespoke shopping service." />
        <meta property="og:title" content="Cigars - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Curating premium cigars and rare tobacco from exclusive manufacturers through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/cigars" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/CIGARS/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Premium Cigars" />
      </Helmet>
      
      <ServicePageTemplate config={cigarsConfig} />
    </>
  )
}

export default CigarsPage